import { defineState } from '../storage/define-state.js';
import { declareState } from '../storage/declare-state.js';
import { string } from '../typing/string.js';
import { date } from '../typing/date.js';
import { optional } from '../typing/optional.js';
import { TypeOfStateDeclaration } from '../storage/state-declaration.js';
import { object } from '../typing/object.js';
import { number } from '../typing/number.js';
import { literal } from '../typing/literal.js';
import { TransactionOperation } from '../storage/transaction-operation.js';
import { union } from '../typing/union.js';
import { TypeOf } from '../typing/type-of.js';
import { array } from '../typing/array.js';

export const ProcessorOperationSuccessResult = object(
  'ProcessorOperationSuccessResult',
  {
    success: literal(true),
    eventId: string(),
    outputs: array(
      object('ProcessorOperationSuccessResultOutput', {
        id: string(),
        type: string(),
      }),
    ),
  },
);
export type ProcessorOperationSuccessResult = TypeOf<
  typeof ProcessorOperationSuccessResult
>;
export const ProcessorOperationFailureResult = object(
  'ProcessorOperationFailureResult',
  {
    eventId: string(),
    success: literal(false),
    error: string(),
    stacktrace: optional(string()),
  },
);
export type ProcessorOperationFailureResult = TypeOf<
  typeof ProcessorOperationFailureResult
>;
export const ProcessorOperationResult = union('ProcessorOperationResult', [
  ProcessorOperationSuccessResult,
  ProcessorOperationFailureResult,
]);
export type ProcessorOperationResult = TypeOf<typeof ProcessorOperationResult>;

export const StateProcessorOperation = declareState(
  'operations',
  {
    eventId: string(),
    result: ProcessorOperationResult,
    appliedAt: date(),
    eventAt: date(),
  },
  ['eventId'],
)
  .index('eventAt', ['eventAt'] as const)
  .index('appliedAt', ['appliedAt'] as const);

export type StateProcessorOperation = TypeOfStateDeclaration<
  typeof StateProcessorOperation
>;

export const StateProcessorState = defineState([
  StateProcessorOperation,
  declareState(
    'stateOperations',
    {
      transaction: TransactionOperation,
      eventId: string(),
      sourceEventDate: date(),
      transactionIndex: number(),
    },
    ['eventId', 'transactionIndex'],
  ),
  declareState(
    'eventSequence',
    {
      eventId: string(),
      appliedAt: date(),
      error: optional(string()),
    },
    ['eventId'],
  ).index('appliedAt', ['appliedAt'] as const),
]);
